<template>
	<div class="container" id="profile_section">
			<div class="row gold text-center">
				<div class="col-md-6 col-12">
					<h2>
						<i class="fas fa-users"></i> Challenges Archive (<small v-text="totalRows"></small>)
					</h2>
				</div>
			</div>
            <div v-if="user_level >= 90">
				
				<div class="row gold text-center">	
					<a class="challenges-link" href="/challenges">Public Challenges</a>
				</div>
			</div>

			<b-modal id="modal-challenge" :title="modal.title" ref="modal-challenge" no-close-on-backdrop>
				<b-form @submit="submitchallengeForm($event)">
					<b-form-group>
						<small class="text-muted">Challenge Status</small>
						<b-form-select
							v-model="modal.challenge.status"
							:options="statuses"
							@change="validate(modal.challenge)"
						></b-form-select>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Challenge Name</small>
						<b-form-input
							v-model="modal.challenge.title"
							type="text"
							required
							placeholder="Enter challenge name"
							@change="validate(modal.challenge)"
						></b-form-input>
						<small class="text-danger" v-if="modal.challenge.title === ''"
							>Enter a challenge name</small
						>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Challenge Description</small>
						<b-form-textarea
							v-model="modal.challenge.description"
							type="text"
							rows="5"
							required
							placeholder="Enter challenge description"
							@change="validate(modal.challenge)"
						></b-form-textarea>
						<small class="text-danger" v-if="modal.challenge.description === ''"
							>Enter a challenge description</small
						>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Challenge Video</small>
						<b-form-input
							v-model="modal.challenge.video"
							type="text"
							placeholder="Enter YouTube URL (optional)"
							@change="validate(modal.challenge)"
						></b-form-input>
					</b-form-group>

					<b-form-group>
						<b-form-checkbox v-model="modal.challenge.chat">
							Include chatroom
						</b-form-checkbox>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Challenge Subscription Package</small>
						<b-form-input
							v-model="modal.challenge.subscription"
							type="text"
							placeholder="Enter product id (eg. prod_Msn2n85nnLHctl)"
							@change="validate(modal.challenge)"
						></b-form-input>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Resources Link</small>
						<b-form-input
							v-model="modal.challenge.resources"
							type="text"
							placeholder="Enter resources link"
							@change="validate(modal.challenge)"
						></b-form-input>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">
							Select challenge leader/s<br />
							*
							<small class="text-danger"
								>Member account must have a Coach status or higher to be selectable...
							</small>
						</small>
						<v-select
							:options="challenge_leaders"
							:filterable="false"
							:multiple="true"
							@search="challengeLeadersSearch"
							v-model="modal.challenge.challenge_leader_selected"
						>
							<template slot="no-options"> Search and select the challenge leader </template>

							<template slot="option" slot-scope="option">
								<div class="d-center">
									{{ option.label }}
								</div>
							</template>

							<template slot="selected-option" slot-scope="option">
								<div class="selected d-center">
									{{ option.label }}
								</div>
							</template>
						</v-select>

						<small class="text-danger" v-if="modal.challenge.challenge_leader_selected === null">
							Select challenge Leader/s
						</small>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Select challenge members</small>
						<v-select
							:options="challenge_members"
							:filterable="false"
							:multiple="true"
							@search="membersSearch"
							v-model="modal.challenge.challenge_members_selected"
						>
							<template slot="no-options"> Search and select for challenge members </template>

							<template slot="option" slot-scope="option">
								<div class="d-center">
									{{ option.label }}
								</div>
							</template>

							<template slot="selected-option" slot-scope="option">
								<div class="selected d-center">
									{{ option.label }}
								</div>
							</template>
						</v-select>

						<small class="text-danger" v-if="modal.challenge.challenge_members_selected === null"
							>Select challenge members</small
						>
					</b-form-group>
				</b-form>

				<small class="text-danger" v-text="modal.errors.process"></small>

				<template #modal-footer="{ cancel }">
					<div class="w-100 row">
						<div class="col text-left">
							<b-button
								type="button"
								size="md"
								variant="success"
								:disabled="modal.submitDisabled"
								@click="submitchallengeForm()"
								>Save
							</b-button>
						</div>
						<div class="col text-right">
							<b-button
								size="sm"
								@click="confirmBox()"
								name="delete"
								variant="outline-danger"
								>Delete
							</b-button>
							<b-button size="sm" variant="outline-secondary" @click="cancel('cancel')">
								Cancel
							</b-button>
						</div>
					</div>
				</template>
			</b-modal>

			<div class="row" id="challenges_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search challenges"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-4 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-8 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						bordered
						responsive
						:items="challenges"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template v-slot:cell(status)="data">
							<span v-text="arrayElmGet(statuses, data.item.status)"></span>
						</template>

						<template v-slot:cell(challenge_leader_selected)="data">
							<span
								v-for="val in data.item.challenge_leader_selected"
								v-text="val.label + ', '"
								:key="'M_' + val.id"
								class="mr-1"
							></span>
						</template>

						<template v-slot:cell(challenge_members_selected)="data">
							<span
								v-for="val in data.item.challenge_members_selected"
								v-text="val.label + ', '"
								:key="'M_' + val.id"
								class="mr-1"
							></span>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown v-if="user_level >= 90"
								size="sm"
								split
								split-variant="outline-primary"
								class="gold"
								text="View"					
								@click="challengeView(data.item)"
							>
								<b-dropdown-item>
									<div>
										<a href="#" @click="challengeView(data.item)"> View Challenge </a>
									</div>
								</b-dropdown-item>
								<b-dropdown-item v-if="user_level >= 90">
									<div>
										<a href="#" @click="challengeEmail(data.item)"> Email Members </a>
									</div>
								</b-dropdown-item>
								<b-dropdown-item v-if="user_level >= 90">
									<div>
										<a href="#" @click="challengeEdit($event, data.item)"> Edit </a>
									</div>
								</b-dropdown-item>
							</b-dropdown>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>
			</div>
	</div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
	name: 'Challenges',
	components: {
		vSelect,
	},
	props: {},
	data() {
		return {
			modal: {
				title: '',
				description: '',
				video: '',
				chat: false,
				subscription: '',
				resources: '',
				submitDisabled: true,
				challenge: {},
				challenge_leader: '',
				errors: {
					process: '',
					status: '',
				},
			},
			modal_challenge_default: {
				id: 0,
				title: '',
				description: '',
				video: '',
				chat: false,
				subscription: '',
				resources: '',
				status: 1,
				challenge_leader_selected: null,
				challenge_members_selected: null,
			},

			statuses: [
				{ value: 0, text: 'Closed (deleted)' },
				{ value: 1, text: 'Active' },
				{ value: 2, text: 'Pending' },
				{ value: 3, text: 'Archived' },
			],
			errors: {
				join: '',
				join_class: '',
			},
			processing: '',
			challenges: [],
			challenge_leaders: [],
			challenge_members: [],
			leader_item: null,
			challenge_item: null,
			challenge_leaders_email: [],
			fields: [
				{ key: 'actions', sortable: false, label: 'Actions', class: '' },
				{ key: 'title', sortable: true, label: 'Challenge', class: '' },
				{ key: 'challenge_leader_selected', sortable: true, label: 'Challenge Leader', class: '' },
				{ key: 'description', sortable: false, label: 'Description', class: '' },
				//{ key: 'challenge_members_selected', sortable: true, label: 'Members', class: '' },
				{ key: 'status', sortable: true, label: 'Status', class: '' },
			],
			isBusy: true,
			sortBy: 'user_score',
			sortDirection: 'desc',
			sortDesc: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},
		confirmBox() {
			this.$bvModal
				.msgBoxConfirm('Are you sure you want to delete this challenge?')
				.then((value) => {
					if (value == true) {
						this.modal.challenge.status = 0;
						this.submitchallengeForm();
					} else {
						this.$bvModal.hide('modal-challenge');
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		challengeView(item) {
			this.$router.push('/challenges/' + item.id);
		},
		challengeEmail(item) {
			this.$router.push('/challenges/' + item.id + '/email');
		},
		membersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.membersGet(loading, search, this);
			}
		},
		membersGet(loading, search, vm) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'challenge_members');
			axios({
				url: _this.$store.state.api_url + 'challengeMembersSearch',
				params: params,
			})
				.then(function (response) {
					console.log(vm.options); // = response.data.items;
					_this.challenge_members = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: membersGet.');
				});
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		submitchallengeForm(e) {
			let _this = this;
			if (e) {
				e.preventDefault();
			}

			this.validate(_this.modal.challenge);

			_this.modal.errors.process = 'Processing...';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('status', _this.modal.challenge.status);
			params.append('title', _this.modal.challenge.title);
			params.append('description', _this.modal.challenge.description);
			params.append('video', _this.modal.challenge.video);
			params.append('chat', _this.modal.challenge.chat);
			params.append('subscription', _this.modal.challenge.subscription);
			params.append('resources', _this.modal.challenge.resources);
			params.append('id', _this.modal.challenge.id);

			if (_this.modal.challenge.challenge_leader_selected) {
				const challenge_leader = Object.values(_this.modal.challenge.challenge_leader_selected);
				for (const item of challenge_leader) {
					params.append('challenge_leader[]', item.id);
				}
			}

			if (_this.modal.challenge.challenge_members_selected) {
				const challenge_members = Object.values(_this.modal.challenge.challenge_members_selected);
				for (const item of challenge_members) {
					params.append('challenge_members[]', item.id);
				}
			}

			axios({
				url: _this.$store.state.api_url + 'challengeAddEdit',
				params: params,
			})
				.then(function (response) {
					_this.modal.errors.profile = response.data.message;
					if (response.data.status == 1) {
						if (response.data.challenge !== null) {
							if (response.data.type == 'add') {
								_this.challenges.unshift(response.data.challenge);
								_this.modal.challenge = _this.modal_challenge_default;
							} else {
								if (_this.modal.challenge.status === 0) {
									_this.challenges = _this.challenges.filter(
										(item) => item.id !== _this.modal.challenge.id
									);
								} else {
									_this.challenges.find((obj) => {
										if (obj.challenge_leader_user_id === _this.modal.challenge.id) {
											obj = response.data.challenge;
										}
									});
								}
							}
						}

						_this.totalRows = _this.challenges.length;

						_this.modal.errors.process = "Success! Challenge updated.";
						_this.challengesGet();

					} else {
						_this.modal.errors.process = response.data.message;
					}
				})
				.catch(function () {});
		},
		challengeEdit(e, challenge) {
			this.modal.title = 'Edit Challenge';
			this.modal.errors.process = '';
			this.modal.challenge = challenge;

			if (challenge.challenge_leader_selected) {
				this.modal.challenge.challenge_leader_selected = Object.values(challenge.challenge_leader_selected);
			}

			if (challenge.challenge_members_selected) {
				this.modal.challenge.challenge_members_selected = Object.values(challenge.challenge_members_selected);
			}

			this.$bvModal.show('modal-challenge');
			this.validate(this.modal.challenge);
		},
		challengesGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'challengesGet',
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						var allChallenges = Object.values(response.data.challenges);
                        for (const item of allChallenges) {
                            if (item.status == 3) _this.challenges.push(item);
                        }
					} else {
						_this.challenges = null;
					}
					_this.totalRows = _this.challenges.length;
				})
				.catch(function () {
					console.log('Error: challengesGet.');
				});
		},
		challengeLeadersGet(loading, search, vm) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('search_term', search);
			params.append('type', 'challenge_leaders');
			axios({
				url: _this.$store.state.api_url + 'challengeMembersSearch',
				params: params,
			})
				.then(function (response) {
					console.log(vm.options); // = response.data.items;
					_this.challenge_leaders = Object.values(response.data.items);
					loading(false);
				})
				.catch(function () {
					console.log('Error: challengeLeadersGet.');
				});
		},
		challengeLeadersSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.challengeLeadersGet(loading, search, this);
			}
		},
		validate(challenge) {
			var valid = true;
			if (challenge.status === '' || challenge.status === 'null') {
				valid = false;
			}
			if (challenge.title === '') {
				valid = false;
			}

			if (challenge.description === '') {
				valid = false;
			}

			if (valid == true) {
				this.modal.submitDisabled = false;
				return false;
			} else {
				this.modal.submitDisabled = true;
				return true;
			}
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		active_profile() {
			return this.$store.getters.profileGet;
		},
		user_level() {
			return this.active_profile.level;
		},
	},
	created() {},
	mounted() {
		this.challengesGet();
	},
	watch: {},
};
</script>

<style scoped>
.challenges-link {
	margin-bottom: 5px;
	padding-left: 15px;
}
</style>